import S3BLC010007AEU from './S3BL-C010007AEU.js';
export const vtac = { 'S3BL-C010007AEU': S3BLC010007AEU };
